import React, { useState, useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { Helmet } from "react-helmet-async";
import rathYatraBanner from "./assets/WEB POSTER.png";
import img1 from "./assets/img1.jpeg";
import img2 from "./assets/img2.jpeg";
import img3 from "./assets/img3.jpeg";
import img4 from "./assets/img4.jpeg";
import img5 from "./assets/img5.jpeg";
import { MdDateRange } from "react-icons/md";
import { MdAccessTimeFilled } from "react-icons/md";
import { FaMapPin } from "react-icons/fa";
import { MdAppRegistration } from "react-icons/md";
import { FaTrophy } from "react-icons/fa6";
import { FaSpinner } from "react-icons/fa";
import { motion } from "framer-motion";

import { useForm } from "react-hook-form";

import "./walkathon.css";
import RathNavbar from "../Rath Yatra Page/RathNavbar";

const RathYatraWalkathon = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const storeWalkathonFormData = async (data) => {
    const formDataToSend = new URLSearchParams();
    formDataToSend.append("fullName", data.fullName || "");
    formDataToSend.append("gender", data.gender || "");
    formDataToSend.append("contactNumber", data.contactNumber || "");
    formDataToSend.append("instagramId", data.instagramId || "");
    formDataToSend.append("emailId", data.emailId || "");
    formDataToSend.append("tshirtSize", data.tshirtSize || "");
    formDataToSend.append("participationType", data.participationType || "");
    formDataToSend.append("groupName", data.groupName || "");

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbwFYdghCGOeO6CjlKbNqZLXLDKpCzFvr_6zWv9_zdXsnIRt8mEsJG7-073TBIJ3QsNTyw/exec",
        {
          method: "POST",
          // mode: "no-cors", // ✅ Needed to bypass CORS block
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formDataToSend.toString(),
        }
      );

      alert("Walkathon registration successful!");
      return true;
    } catch (err) {
      console.error("Fetch error:", err);
      alert("An error occurred. Please try again.");
      return false;
    }
  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    const success = await storeWalkathonFormData(data);
    if (success) {
      // Optional: Reset form or show a message
      reset(); // If using react-hook-form
    }
    setIsSubmitting(false);
  };

  const images = [img1, img2, img3, img4, img5];

  return (
    <>
      <Helmet>
        <title>Walkathon 2025 | ISKCON Vijayawada</title>
        <meta
          name="description"
          content="Celebrate Narasimha Chaturdashi 2025 with ISKCON Vijayawada! Discover the significance of Lord Narasimhadeva’s appearance, puja rituals, and how to participate in the festival."
        />
        <meta
          name="keywords"
          content="ISKCON Vijayawada Narasimha Chaturdashi, Narasimha Chaturdashi ISKCON Vijayawada, Narasimha Jayanti ISKCON, Narasimha Chaturdashi celebrations at ISKCON Vijayawada, Narasimha Chaturdashi pooja ISKCON Vijayawada, ISKCON Vijayawada festivals, Lord Narasimha festival ISKCON, Narasimha Chaturdashi 2025 ISKCON, Narasimha Jayanti 2025 Vijayawada, Narasimha Chaturdashi puja ISKCON Vijayawada, Lord Narasimha appearance day ISKCON, Narasimha Chaturdashi ritual Vijayawada, ISKCON spiritual events Vijayawada, Narasimha Chaturdashi significance ISKCON, Narasimha avatar celebration ISKCON"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Narasimha Chaturdashi 2025 – Significance, Puja, and Celebrations | ISKCON Vijayawada"
        />
        <meta
          property="og:description"
          content="Celebrate Narasimha Chaturdashi 2025 with ISKCON Vijayawada! Discover the significance of Lord Narasimhadeva’s appearance, puja rituals, and how to participate in the festival."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content=" https://www.iskconvijayawada.org/NarasimhaChaturdashi "
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Narasimha Chaturdashi 2025 – Significance, Puja, and Celebrations | ISKCON Vijayawada"
        />
        <meta
          name="twitter:description"
          content="Celebrate Narasimha Chaturdashi 2025 with ISKCON Vijayawada! Discover the significance of Lord Narasimhadeva’s appearance, puja rituals, and how to participate in the festival."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/Walkathon2025"
        />

        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Sri Jagannath Rath Yatra 2025 | ISKCON Vijayawada",
            "url": "https://www.iskconvijayawada.org/rathyatra",
            "description": "Experience the divine journey of Lord Jagannath’s Rath Yatra 2025 in Vijayawada. Join ISKCON's spiritual celebration with kirtans, prasadam, and more.",
            "publisher": {
              "@type": "Organization",
              "name": "ISKCON Vijayawada",
              "url": "https://www.iskconvijayawada.org",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.iskconvijayawada.org/static/media/RathY.55f3f04ad28fba22c824.jpeg"
              }
            }
          }
        `}
        </script>

        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Event",
            "name": "Sri Jagannath Rath Yatra 2025",
            "startDate": "2025-07-06T08:00:00+05:30",
            "endDate": "2025-07-06T20:00:00+05:30",
            "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
            "eventStatus": "https://schema.org/EventScheduled",
            "location": {
              "@type": "Place",
              "name": "ISKCON Vijayawada",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "ISKCON Temple, Governorpet",
                "addressLocality": "Vijayawada",
                "addressRegion": "AP",
                "postalCode": "520002",
                "addressCountry": "IN"
              }
            },
            "image": [
              "https://www.iskconvijayawada.org/static/media/RathY.55f3f04ad28fba22c824.jpeg"
            ],
            "description": "Join the grand celebration of Sri Jagannath Rath Yatra 2025 organized by ISKCON Vijayawada. Experience devotional kirtans, prasadam distribution, and the spiritual chariot procession.",
            "organizer": {
              "@type": "Organization",
              "name": "ISKCON Vijayawada",
              "url": "https://www.iskconvijayawada.org"
            }
          }
        `}
        </script>
      </Helmet>

      {/* <Header /> */}
      <RathNavbar />
      <div className="ramnavami-container  ">
        <div className="ramnavami-banner  ">
          <img
            loading="lazy"
            src={rathYatraBanner}
            alt="main Img"
            className="ramnavami-banner-img md:mt-[0px]"
          />
        </div>
        <div
          className="ramnavami-content-bg md:pb-[20px] pb-1 flex justify-center flex-col items-center"
          // style={{ backgroundImage: `url(${thirdbg})` }}
        >
          {/* <img
            src={RYMainHeading}
            alt="RYMainHeading"
            className="mt-5 md:w-[38%] w-[320px] "
          /> */}
          <div className="walkathon-content md:mt-16 mt-0  ">
            <span className="flex justify-center items-center gap-4"></span>
            {/* <h2 className="ramnavami-subheadline text-center">A Grand Celebration at ISKCON Vijayawada</h2> */}
            <div className="ramnavami-text-container mb-[60px]">
              <div className="ramnavami-text-content">
                <h2 className="text-center font-bold text-[#c61d21] md:text-5xl text-3xl  bg-gradient-to-br from-orange via-red via-orange-500 to-orange text-transparent bg-clip-text ">
                  <i>WALKATHON - 2025</i>
                </h2>
                <br />
                <h3 className="text-[#c61d21] tracking-normal walk-main-heading">
                  {/* <b> */}
                  Join us for a vibrant and purposeful Walkathon on June 15,
                  2025, being organized as part of the Amaravati Rathayatra in
                  Vijayawada
                  {/* </b> <br /><br /> */}
                </h3>
                <br />

                <p className="spacing-issue  md:text-xl ">
                  <h2 className=" text-center  font-bold text-[#c61d21] md:text-3xl text-xl">
                    {" "}
                    Walk&nbsp;With&nbsp;Purpose.&nbsp;Rise&nbsp;Against&nbsp;Addiction.
                  </h2>
                  <span className="theam text-center flex justify-center items-center md:text-2xl">
                    <b>Theme&nbsp;for&nbsp;Walkathon: </b>
                    <b className="text-[#c61d21]  ">
                      {" "}
                      Unite&nbsp;Against&nbsp;Addiction
                    </b>{" "}
                  </span>
                  <br />
                  <b>EarthHeroes Foundation</b>, in collaboration with
                  <a
                    className="no-underline"
                    href="https://www.iskconvijayawada.org/"
                  >
                    {" "}
                    <b>ISKCON Vijayawada</b>
                  </a>{" "}
                  , proudly presents the Walkathon <b>Against Drug Addiction</b>{" "}
                  as a key initiative of the Amaravati Rathyatra. <br />
                  In an era where substance abuse threatens the spirit of our
                  youth, let’s take a collective stand. This isn’t just a walk —
                  it’s a <b>movement of awareness</b>, strength, and
                  transformation. <br />
                  Step forward. Speak out. Together, let’s turn devotion into
                  action and build a <b>drug-free</b>, conscious India. <br />
                  {/* aligning with efforts to raise <b>awareness</b> ahead of the <b>International Day Against Drug Abuse (June 26).</b> <br />
                  Let’s walk together to promote a <b>healthy</b>,<b> addiction-free</b> lifestyle and inspire positive change in our communities. Your steps can help pave the way for a <b>Drug-Free Andhra Pradesh!</b> <br /><br /> */}
                  <br />
                  <div className="space-y-2 text-sm md:text-xl tt">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <MdDateRange
                              className="text-[#c61d21]"
                              style={{ fontSize: "1.25rem" }}
                            />
                          </td>
                          <td className="label text-[#c61d21]">
                            <b>Date:</b>
                          </td>
                          <td className="tablet-content">
                            <b>June 15, 2025</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <MdAccessTimeFilled
                              className="text-[#c61d21]"
                              style={{ fontSize: "1.25rem" }}
                            />
                          </td>
                          <td className="label text-[#c61d21]">
                            <b>Starting&nbsp;Point:</b>
                          </td>
                          <td className="tablet-content">
                            <b>Eatstreet, near Indira Gandhi Stadium</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <FaMapPin
                              className="text-[#c61d21]"
                              style={{ fontSize: "1.25rem" }}
                            />
                          </td>
                          <td className="label text-[#c61d21]">
                            <b>Reporting&nbsp;Time:</b>
                          </td>
                          <td className="tablet-content">
                            <b>6:30 AM</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <FaTrophy
                              className="text-[#c61d21]"
                              style={{ fontSize: "1.25rem" }}
                            />
                          </td>
                          <td className="label text-[#c61d21]">
                            <b>Participant&nbsp;Perks:</b>
                          </td>
                          <td className="tablet-content">
                            <b>
                              Participation certificates, T-shirts, and
                              refreshments will be provided.
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* <div className="flex  md:flex-row md:items-center gap-1">
                      <MdAppRegistration className="text-[#c61d21]" />
                      <b className="text-[#c61d21]">Registration Link:</b>
                      <a href="http://bit.ly/walkathon25" target="_blank" rel="noreferrer" className="no-underline text-blue-600">
                        <b>Click here 👈🏻</b>
                      </a>
                    </div> */}
                  </div>
                </p>
              </div>
            </div>
            {/* <h2 className="ramnavami-subheadline text-center text-4xl md:text-3xl ">
              SCHEDULE ON RATH YATRA DAY (27TH JUNE)
            </h2> */}
          </div>
        </div>

        <div className="walkathon-layout-container">
          {" "}
          {/* NEW CONTAINER */}
          <div className="walkathon-image-grid">
            {" "}
            {/* NEW DIV FOR IMAGES */}
            {images.map((img, index) => (
              <div className="img-box-styling">
                <img
                  key={index}
                  src={img}
                  alt={"img"}
                  className="walkathon-grid-item" // Add a class for styling
                />
              </div>
            ))}
          </div>
          <div className="unioye-form-wrapper">
            <div className="unioye-form-container">
              <h2 className="unioye-form-title">Walkathon Registration</h2>

              <form
                onSubmit={handleSubmit(onSubmit)}
                className="unioye-form unioye-form-background"
              >
                {/* Full Name */}
                <div className="unioye-form-group">
                  <label className="unioye-form-label">Full Name *</label>
                  <input
                    {...register("fullName", { required: true })}
                    className="unioye-form-input"
                    placeholder="Enter your full name"
                  />
                  {errors.fullName && (
                    <p className="unioye-error-message">
                      This field is required
                    </p>
                  )}
                </div>

                {/* Gender */}
                <div className="unioye-form-group">
                  <label className="unioye-form-label">Gender *</label>
                  <div className="unioye-form-radio-group">
                    <label className="unioye-form-radio-label">
                      <input
                        type="radio"
                        value="Male"
                        {...register("gender", { required: true })}
                        className="unioye-form-radio-input"
                      />
                      Male
                    </label>
                    <label className="unioye-form-radio-label">
                      <input
                        type="radio"
                        value="Female"
                        {...register("gender", { required: true })}
                        className="unioye-form-radio-input"
                      />
                      Female
                    </label>
                    <label className="unioye-form-radio-label">
                      <input
                        type="radio"
                        value="Prefer not to say"
                        {...register("gender", { required: true })}
                        className="unioye-form-radio-input"
                      />
                      Prefer not to say
                    </label>
                    <label className="unioye-form-radio-label">
                      <input
                        type="radio"
                        value="Other"
                        {...register("gender", { required: true })}
                        className="unioye-form-radio-input"
                      />
                      Other
                    </label>
                  </div>
                  {errors.gender && (
                    <p className="unioye-error-message">
                      This field is required
                    </p>
                  )}
                </div>

                {/* Contact Number */}
                <div className="unioye-form-group">
                  <label className="unioye-form-label">Contact Number *</label>
                  <input
                    type="tel"
                    {...register("contactNumber", {
                      required: true,
                      pattern: /^[0-9]{10}$/,
                    })}
                    className="unioye-form-input"
                    placeholder="Enter 10-digit number"
                  />
                  {errors.contactNumber && (
                    <p className="unioye-error-message">
                      Valid number is required
                    </p>
                  )}
                </div>

                {/* Instagram ID */}
                <div className="unioye-form-group">
                  <label className="unioye-form-label">Instagram ID *</label>
                  <input
                    {...register("instagramId", { required: true })}
                    className="unioye-form-input"
                    placeholder="@yourusername"
                  />
                  {errors.instagramId && (
                    <p className="unioye-error-message">
                      This field is required
                    </p>
                  )}
                </div>

                {/* Email ID */}
                <div className="unioye-form-group">
                  <label className="unioye-form-label">Email ID *</label>
                  <input
                    type="email"
                    {...register("emailId", {
                      required: true,
                      pattern: /^\S+@\S+$/i,
                    })}
                    className="unioye-form-input"
                    placeholder="Enter your email"
                  />
                  {errors.emailId && (
                    <p className="unioye-error-message">
                      Valid email is required
                    </p>
                  )}
                </div>

                {/* T-shirt Size */}
                <div className="unioye-form-group">
                  <label className="unioye-form-label">T-shirt Size *</label>
                  <select
                    {...register("tshirtSize", { required: true })}
                    className="unioye-form-select"
                  >
                    <option value="">Select size</option>
                    <option>S</option>
                    <option>M</option>
                    <option>L</option>
                    <option>XL</option>
                    <option>XXL</option>
                  </select>
                  {errors.tshirtSize && (
                    <p className="unioye-error-message">
                      This field is required
                    </p>
                  )}
                </div>

                {/* Participation Type */}
                <div className="unioye-form-group">
                  <label className="unioye-form-label">
                    Are you participating as an individual or part of a group? *
                  </label>
                  <div className="unioye-form-radio-group">
                    <label className="unioye-form-radio-label">
                      <input
                        type="radio"
                        value="Individual"
                        {...register("participationType", { required: true })}
                        className="unioye-form-radio-input"
                      />
                      Individual
                    </label>
                    <label className="unioye-form-radio-label">
                      <input
                        type="radio"
                        value="Group"
                        {...register("participationType", { required: true })}
                        className="unioye-form-radio-input"
                      />
                      Group
                    </label>
                  </div>
                  {errors.participationType && (
                    <p className="unioye-error-message">
                      This field is required
                    </p>
                  )}
                </div>

                {/* Group Name (only if Group is selected) */}
                <div className="unioye-form-group">
                  <label className="unioye-form-label">
                    If Group, mention the name of the group or organisation *
                  </label>
                  <input
                    {...register("groupName", {
                      validate: (value) => {
                        if (watch("participationType") === "Group" && !value) {
                          return "Group name is required if you selected Group";
                        }
                        return true;
                      },
                    })}
                    className="unioye-form-input"
                    placeholder="Group or organisation name"
                  />
                  {errors.groupName && (
                    <p className="unioye-error-message">
                      {errors.groupName.message}
                    </p>
                  )}
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="unioye-form-submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <FaSpinner className="unioye-spinner" />
                  ) : (
                    "Submit"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RathYatraWalkathon;
